
import React from 'react';


import {
	createPayment_69fce3d85276935741630b32,
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_carriton0fqi,
} from '../../actions/auth.actions';


import './principalj2t5n.scss';


const loftyShouldRenderCarousel = (products = []) => {
  const loftyIsMobile = window.innerWidth < 464;
  if (loftyIsMobile) {
    return true;
  }
  return products.length > 3;
}


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pprincipalj2t5n = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_carriton0fqi,
	set_lofty_global_carriton0fqi_app,

}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69cd69a5ee7dda37b6dc73ba" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i6edva"
          href="/"
        >
          
    <div id="iysqr8" className="">
    <>Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iy44bl"
          href="/menu"
        >
          
    <div id="i41p5g" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyf8jb"
          href="/eventos"
        >
          
    <div id="iztdq8" className="">
    <>Reservaciones</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i377lh"
          href="/unite"
        >
          
    <div id="io6x2g" className="">
    <>Únete a nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i3knlt"
          href="/ubicaciones"
        >
          
    <div id="ie1esj" className="">
    <>Ubicaciones</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="inff1e" className="">
      
        <a
          target=""
          className=""
          id="ijhswy"
          href="/carrito"
        >
          
    <div id="i7kn2y" className="">
    <>Carrito</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Menú</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Reservaciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Únete a nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Ubicaciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Carrito</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihk8" className="">
      
      <div id="iym0il" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Sabores Auténticos de Honduras</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i803s">
        <>Tradición y calidad en cada platillo</>
      <br className="" id="" />
      
      </div>
      
      <div id="ij879e" className="">
      
        <a
          target=""
          className=""
          id="i97gow"
          href="#"
        >
          
      <span className="" id="ixit2n">
        <>Ménu</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="izdkrq" className="">
      
      <div id="iou2cz" className="">
      
      <div id="iqpteu" className="">
      
      <img
        className=""
        id="iib6bz"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngfafiq.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6wf3u" className="">
      
      <div className="" id="ioqst2">
        <>SOBRE NOSOTROS</>
      </div>
      
      <div className="" id="iucktz">
        <>Una Tradición que Nace del Corazón</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ira3vu">
        <>En Típicos Menche, cada platillo cuenta una historia. Somos un restaurante familiar fundado con el sueño de compartir los auténticos sabores de Honduras con el mundo. Nuestras recetas han pasado de generación en generación, conservando la esencia de la cocina catracha tradicional.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Desde nuestras famosas baleadas hasta el plato típico completo, cada ingrediente es seleccionado con cuidado para ofrecerte una experiencia gastronómica única. Más que un restaurante, somos un pedacito de Honduras donde el sabor, la calidez y la tradición se unen en cada visita.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="iiaa8f">
        <>Nuestra Esencia</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijh55q">
        <>Lo Que Nos Define</>
      <br className="" id="" />
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div id="idydx" className="card ">
      
      <div id="ikpy3f" className="">
      
      <div id="im9bo1" className="">
      
      <img
        className=""
        id="i1jvnf"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngfkjpg.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iqypdu">
        <>Misión</>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iyi33">
        <>Ofrecer comida típica hondureña de alta calidad, elaborada con ingredientes frescos y procesos estandarizados basados en mejores prácticas internacionales, brindando un servicio de excelencia en un ambiente familiar, ordenado y accesible, preservando y promoviendo la tradición culinaria del país.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i56t75" className="card ">
      
      <div id="i6tai" className="">
      
      <div id="i4blkk" className="">
      
      <img
        className=""
        id="ilqcl"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngfnf00.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ivfd5">
        
      <span className="" id="ivmwlh">
        <>Visión</>
      </span>
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iit6zr">
        <>Consolidar a Típicos Menche como una cadena de restaurantes reconocida a nivel nacional e internacional por su calidad, eficiencia operativa y experiencia superior al cliente, aplicando mejores prácticas globales en gestión, producción y servicio, desarrollando infraestructura propia y un modelo de negocio escalable y sostenible.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="igv06w" className="">
      
      <div className="" id="i7b12c">
        <>Nuestros Valores</>
      </div>
      
      <div className="" id="ikbi5a">
        <>Los Pilares de Nuestra Identidad</>
      <br className="" id="" />
      
      </div>
      
      <div id="iom5vq" className="">
      
      <div id="ioebvu" className="card ">
      
      <div id="iq4s3c" className="">
      
      <div id="ic8zph" className="">
      
      <img
        className=""
        id="im76yj"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1vxw6i.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="i4imie">
        <>Calidad</>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iempx2">
        <>Compromiso con productos frescos, procesos estandarizados y excelencia en cada preparación.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i16fp8" className="card ">
      
      <div id="igdbx9" className="">
      
      <div id="ivpw1h" className="">
      
      <img
        className=""
        id="i0v0wh"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1vyxp2.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="itcblc">
        
      <span className="" id="itlu53">
        <>Tradición</>
      </span>
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="icgau1">
        <>Preservación de la gastronomía hondureña como eje central de la identidad del negocio.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="idhiek" className="card ">
      
      <div id="ifc0yy" className="">
      
      <div id="ijcejg" className="">
      
      <img
        className=""
        id="iv3cdh"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1w04b2.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iza23h">
        <>Excelencia en Servicio</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="ijllb8">
        <>Atención cálida, profesional y orientada a la satisfacción del cliente, inspirada en estándares internacionales de hospitalidad.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i2hj2a" className="card ">
      
      <div id="ih8vyk" className="">
      
      <div id="iy49va" className="">
      
      <img
        className=""
        id="iwuhez"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1w0wyr.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iwlkrh">
        <>Honestidad</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="icxqip">
        <>Transparencia y ética en la gestión, relaciones comerciales y atención al cliente.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i1bp8g" className="card ">
      
      <div id="ingm6k" className="">
      
      <div id="ilxjkd" className="">
      
      <img
        className=""
        id="i5xbaj"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1w1tqa.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="imti4z">
        <>Responsabilidad</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="isx8dj">
        <>Cumplimiento de compromisos operativos, financieros y sociales.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="ihy9be" className="card ">
      
      <div id="i4dfof" className="">
      
      <div id="io41nt" className="">
      
      <img
        className=""
        id="ijh83o"
        src="https://assetsprojects.s3.amazonaws.com/405gznimo1w3lrn.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="i5o1vw">
        <>Eficiencia</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="ief5di">
        <>Uso óptimo de recursos, mejora continua y adopción de mejores prácticas internacionales para garantizar sostenibilidad y crecimiento.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i7qj2" className="">
      
      <div id="i97ee" className="">
      
      <div className="" id="i9rwf">
        <>¿Listo para disfrutar el auténtico sabor hondureño?</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iml2p">
        <>Haz tu pedido ahora y recibe tus platillos favoritos en la comodidad de tu hogar o visítanos en cualquiera de nuestras ubicaciones.</>
      </div>
      
      <div id="ilwe4l" className="">
      
        <a
          target=""
          className=""
          id="i2gkn1"
          href="#"
        >
          
      <span className="" id="igjlbq">
        <>Ménu</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div className="" id="iyo7r6">
        <>Sabores auténticos de Honduras. Tradición, calidad y amor en cada platillo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="i78qcc">
        <>+504 9999-9999</>
      </div>
      
      <div className="" id="il1rnw">
        <>info@correo.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_carriton0fqi_app: (value) => dispatch(set_lofty_global_carriton0fqi(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pprincipalj2t5n);
  